import React from 'react';
import { PREFERENCIAS, FUENTE, useTema } from './tema';

/**
 * SelectorTema — claro, oscuro o el del sistema.
 *
 * Tres opciones y no un interruptor de dos: "sistema" no es un punto medio
 * entre las otras dos, es delegar la decisión. Quien tiene el equipo en
 * automático (claro de día, oscuro de noche) quiere que la app le siga, y eso
 * no se puede expresar con un interruptor.
 *
 * Por eso, cuando está en "sistema", debajo se dice qué está aplicando ahora
 * mismo: si no, un usuario con el equipo en oscuro no sabría si la app le está
 * haciendo caso o simplemente está en oscuro.
 */
const SelectorTema = ({ compacto = false }) => {
  const { C, modo, preferencia, cambiar } = useTema();

  const boton = (opcion) => {
    const activa = preferencia === opcion.id;
    return (
      <button
        key={opcion.id}
        onClick={() => cambiar(opcion.id)}
        aria-pressed={activa}
        title={`Apariencia: ${opcion.etiqueta.toLowerCase()}`}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6,
          padding: compacto ? '5px 8px' : '8px 10px',
          fontSize: compacto ? 12 : 13,
          fontFamily: FUENTE,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          border: 'none',
          borderRadius: 7,
          background: activa ? C.acento : 'transparent',
          color: activa ? C.acentoTexto : C.suave,
          fontWeight: activa ? 600 : 400,
          transition: 'background .15s, color .15s'
        }}
      >
        <span aria-hidden="true">{opcion.icono}</span>
        {!compacto && opcion.etiqueta}
      </button>
    );
  };

  return (
    <div>
      <div
        role="group"
        aria-label="Apariencia"
        style={{
          display: 'flex',
          gap: 3,
          padding: 3,
          background: C.panelAlto,
          border: `1px solid ${C.borde}`,
          borderRadius: 9
        }}
      >
        {PREFERENCIAS.map(boton)}
      </div>

      {preferencia === 'sistema' && !compacto && (
        <div style={{ fontSize: 12, color: C.tenue, marginTop: 7 }}>
          Tu sistema está en {modo}.
        </div>
      )}
    </div>
  );
};

export default SelectorTema;
